import { HubType } from '../../../init/proto_client';

export const hubTypeNameMap = {
  [HubType.HUB_TYPE_DATA_COLLECTION_HUB]: 'DCH',
  [HubType.HUB_TYPE_SOTER_COACH_HUB]: 'SoterCoach Hub',
  [HubType.HUB_TYPE_NONE]: '-',
};
